<template>
  <div v-if="centered" class="text-center" :class="containerClass">
    <div
      class="spinner-border"
      :class="[sizeClass, colorClass]"
      role="status"
    >
      <span class="visually-hidden">{{ srText }}</span>
    </div>
    <span v-if="text" class="ms-2">{{ text }}</span>
  </div>
  <div v-else :class="containerClass">
    <div
      class="spinner-border"
      :class="[sizeClass, colorClass]"
      role="status"
    >
      <span class="visually-hidden">{{ srText }}</span>
    </div>
    <span v-if="text" class="ms-2">{{ text }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  size: {
    type: String,
    default: '',
    validator: (value) => ['', 'sm', 'lg'].includes(value)
  },
  color: {
    type: String,
    default: 'primary',
    validator: (value) => ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'blue', 'azure', 'indigo', 'purple', 'pink', 'red', 'orange', 'yellow', 'lime', 'green', 'teal', 'cyan'].includes(value)
  },
  text: {
    type: String,
    default: ''
  },
  srText: {
    type: String,
    default: 'Loading...'
  },
  centered: {
    type: Boolean,
    default: true
  },
  containerClass: {
    type: String,
    default: ''
  }
});

const sizeClass = computed(() => props.size ? `spinner-border-${props.size}` : '');
const colorClass = computed(() => `text-${props.color}`);
</script>
